// const host = "http://hotelapi.net-tactic.com/api/v1/";
const hostUrl = "http://hotelapi.net-tactic.com/" //正式站
const host = "http://www.dci-hotel.com/api/v1/"; //正式站
// const host = "https://dongcheng.net-tactic.com/api/v1/"; //测试站
const hostPath = "https://dongcheng.net-tactic.com/"; //测试站
// const hostUrl = "http://dongcheng.net-tactic.com/"
//域名接口  
export default {
    host,
    hostUrl,
    hostPath
}


// WEBPACK FOOTER //
// ./src/util/global.js